export default __webpack_public_path__ + "static/media/alertCircleYellow.88d1b409.svg";